var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "search-input" }, [_c('el-input', { attrs: { "placeholder": _vm.config.field.placeholder }, on: { "change": _vm.inputChange }, model: { value: _vm.formModel[_vm.config.prop], callback: function callback($$v) {
        _vm.$set(_vm.formModel, _vm.config.prop, $$v);
      }, expression: "formModel[config.prop]" } }, [_c('i', { staticClass: "el-icon-search", attrs: { "slot": "suffix" }, on: { "click": function click($event) {
        return _vm.inputChange(_vm.formModel[_vm.config.prop]);
      } }, slot: "suffix" })])], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };